import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/outline";
import BranchDetails from "../../components/Branch/views/BranchDetails";

const BranchDetailsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="mx-auto sm:p-6 p-4">
      <button
        onClick={() => navigate("/branches")}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4"
      >
        <ArrowLeftIcon className="h-4 w-4" />
        Back to Branches
      </button>

      <BranchDetails />
    </div>
  );
};

export default BranchDetailsPage;
